import { cn } from "@sunfish/lib/utils";
import React from "react";

import { SunfishMark } from "./sunfish-mark";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
};

export const Spinner: React.FC<SpinnerProps> = ({ size = "md", className }) => {
  return (
    <span role="status" className="inline-flex">
      <SunfishMark
        role="img"
        aria-label="Loading"
        aria-hidden={false}
        className={cn(
          "motion-safe:animate-fish-spin-fast motion-reduce:opacity-70",
          sizeClasses[size],
          className,
        )}
      />
    </span>
  );
};
